export default __webpack_public_path__ + "static/media/imgLightEn7.de6f8fac.png";